import { render, staticRenderFns } from "./cartItems.vue?vue&type=template&id=1c13f3c5&scoped=true&"
import script from "./cartItems.vue?vue&type=script&lang=js&"
export * from "./cartItems.vue?vue&type=script&lang=js&"
import style0 from "./cartItems.vue?vue&type=style&index=0&id=1c13f3c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13f3c5",
  null
  
)

export default component.exports